import { render, staticRenderFns } from "./CombinationsProductTable.vue?vue&type=template&id=b5f858fe&scoped=true"
import script from "./CombinationsProductTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsProductTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsProductTable.vue?vue&type=style&index=0&id=b5f858fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f858fe",
  null
  
)

export default component.exports